import Managers from './Managers';
import TrelifAdmin from './TrelifAdmin'

export default {
  ...Managers,
  ...TrelifAdmin,
};